import $ from 'jquery';

$(document).ready(function() {
	$(document).on('keyup', '.js-modal-review-input', function() {
		setTimeout(function() {
			if ($('.js-modal-review-input-name').val() !== '' && 
				$('.js-modal-review-input-email').val() !== '' && 
				$('.js-modal-review-input-message').val() !== '') {
				$('.js-modal-review-button').prop("disabled", false);
			} else {
				$('.js-modal-review-button').prop("disabled", true);
			}
		}, 10);
	});
	$(document).on('click', '.js-modal-review-button', function() {
		if ($('.js-modal-review-checkbox').find('input').is(":checked")) {
			$('.js-modal-review').hide();
			$('body').removeClass('fixed-position-modal');
			$('.js-modal-review-input').val('');
			$('.js-modal-review-rating-button').removeClass('active');
			$('.js-modal-review-rating-button-positive').addClass('active');
			$('.js-modal-review-checkbox').find('input').prop("checked", false);
			$('.js-modal-review-checkbox').removeClass('has-error');
			$('.js-modal-review-button').prop("disabled", true);
		} else {
			$('.js-modal-review-checkbox').addClass('has-error');
		}
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/reviews/modal-review-button.js